import store from "@/store";

/**
 * v-permission directive
 *
 * Usage:
 *   <el-button v-permission="'invoices.create'">Nueva Factura</el-button>
 *   <div v-permission="['invoices.view', 'quotes.view']">Visible if any</div>
 */
const permission = {
  inserted(el, binding) {
    const value = binding.value;

    if (!value) return;

    const hasAccess = Array.isArray(value)
      ? store.getters.hasAnyPermission(value)
      : store.getters.hasPermission(value);

    if (!hasAccess) {
      el.style.display = "none";
      el.setAttribute("data-permission-hidden", "true");
    }
  },
  update(el, binding) {
    const value = binding.value;

    if (!value) return;

    const hasAccess = Array.isArray(value)
      ? store.getters.hasAnyPermission(value)
      : store.getters.hasPermission(value);

    if (!hasAccess) {
      el.style.display = "none";
      el.setAttribute("data-permission-hidden", "true");
    } else {
      if (el.getAttribute("data-permission-hidden") === "true") {
        el.style.display = "";
        el.removeAttribute("data-permission-hidden");
      }
    }
  }
};

export default permission;
